// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-1EqL2","title":"title-1okKW","text":"text-1bxCb","footer":"footer-1xS9Z"};